'use client';

import { ChangeEvent, useMemo } from 'react';

import { useAutoMaskContext } from '@/src/providers';
import { calculatePercent } from '@/src/utils/calculatePercent';
import { cn } from '@/src/utils/cn';

const MIN_RANGE = 1;
const MAX_RANGE = 30;
const STEP = 0.1;

export const BrushSize = () => {
  const { brushSize, setBrushSize } = useAutoMaskContext();

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const val = Number(event.currentTarget.value);

    setBrushSize(val);
  };

  const sliderPercent = useMemo(
    () => calculatePercent(brushSize, [MIN_RANGE, MAX_RANGE]),
    [brushSize],
  );

  return (
    <div
      className={
        'grid w-full items-center gap-4 rounded-t-xl bg-fill-quinary px-3 transition-padding-grid-rows mt-4 mb-1 grid-rows-[1fr] opacity-100'
      }
    >
      <div className="flex min-h-0 flex-col duration-300 delay-200">
        <div className="relative my-4 flex h-1 min-h-0 w-full items-center justify-center rounded-sm bg-fill-switch">
          <input
            type="range"
            min={MIN_RANGE}
            max={MAX_RANGE}
            step={STEP}
            value={brushSize}
            className={cn(
              'm-0 h-8 w-full touch-none appearance-none rounded-full border-0 bg-transparent p-0 outline-0',
              'input-thumb:size-4 input-thumb:cursor-ew-resize input-thumb:appearance-none input-thumb:rounded-full input-thumb:border-0 input-thumb:bg-fill-white',
              'input-track:bg-transparent',
            )}
            onChange={onChange}
          />
          <div
            className="pointer-events-none absolute top-0 left-0 h-1 rounded-sm bg-fill-white"
            style={{ width: `${sliderPercent}%` }}
          />
        </div>
      </div>
    </div>
  );
};
